"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.createPollingJsonRpcProviderForListeners = exports.assertIsPollingProvider = void 0;
const polling_json_rpc_provider_1 = require("./polling-json-rpc-provider");
const isPollingProvider = (provider) => {
    return (provider.providerType === 'jsonrpc' && provider.isPollingProvider);
};
const assertIsPollingProvider = (provider) => {
    if (!isPollingProvider(provider)) {
        throw new Error('The JsonRpcProvider must have polling enabled. Use PollingJsonRpcProvider to instantiate.');
    }
};
exports.assertIsPollingProvider = assertIsPollingProvider;
/**
 * Fallback Providers don't poll correctly for events.
 * This function creates a PollingJsonRpcProvider from the first provider in the FallbackProvider.
 */
const createPollingJsonRpcProviderForListeners = async (provider, chainId, pollingInterval) => {
    if (isPollingProvider(provider)) {
        return provider;
    }
    if (provider.providerType === 'jsonrpc') {
        // eslint-disable-next-line no-underscore-dangle
        const { url } = provider._getConnection();
        return new polling_json_rpc_provider_1.PollingJsonRpcProvider(url, chainId, pollingInterval);
    }
    if (provider.providerType === 'fallback') {
        // FallbackProvider only
        if (!provider.providerConfigs.length) {
            throw new Error('Requires 1+ providers in FallbackProvider');
        }
        const firstProvider = provider.providerConfigs[0].provider;
        if (firstProvider.providerType !== 'jsonrpc') {
            throw new Error('First provider in FallbackProvider must be JsonRpcProvider');
        }
        // eslint-disable-next-line no-underscore-dangle
        const { url } = firstProvider._getConnection();
        // eslint-disable-next-line no-underscore-dangle
        const maxLogsPerBatch = firstProvider._getOption('batchMaxCount');
        return new polling_json_rpc_provider_1.PollingJsonRpcProvider(url, chainId, pollingInterval, maxLogsPerBatch);
    }
    throw new Error('Invalid ethers provider type');
};
exports.createPollingJsonRpcProviderForListeners = createPollingJsonRpcProviderForListeners;
